export default function _complement(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}


// WEBPACK FOOTER //
// /app/apps/ms/node_modules/ramda/es/internal/_complement.js